export default "https://cdn-static.gokick.com/assets/24c3578bda803cdf114b208e53f44151315faa60/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";